import "core-js/modules/es.array.join";
import { memberStatus as memberStatusType } from 'enums/memberStatus';
import { PLAN_DOES_NOT_ALLOW_RESERVATIONS, RESERVED } from 'constants/availability-reasons';
import { SCHEDULE_CTA_BY_NAME } from 'constants/schedule-ctas';
import ScheduleDeriver from 'derivers/Schedules';
var cancel = SCHEDULE_CTA_BY_NAME.cancel,
    buy = SCHEDULE_CTA_BY_NAME.buy,
    signup = SCHEDULE_CTA_BY_NAME.signup,
    reserve = SCHEDULE_CTA_BY_NAME.reserve,
    disable = SCHEDULE_CTA_BY_NAME.disable,
    reactivate = SCHEDULE_CTA_BY_NAME.reactivate,
    join = SCHEDULE_CTA_BY_NAME.join;

var getScheduleAction = function getScheduleAction(memberStatus, schedule) {
  var _ScheduleDeriver$avai = ScheduleDeriver.availabilityData(schedule),
      availableToPurchase = _ScheduleDeriver$avai.availableToPurchase,
      availableToReserve = _ScheduleDeriver$avai.availableToReserve,
      reasonCode = _ScheduleDeriver$avai.reasonCode;

  switch (memberStatus) {
    case memberStatusType('UNPAID'):
    case memberStatusType('ACTIVE'):
      if (reasonCode === RESERVED) {
        return cancel;
      }

      if (!availableToReserve && availableToPurchase) {
        return buy;
      }

      if (!availableToReserve && reasonCode === PLAN_DOES_NOT_ALLOW_RESERVATIONS) {
        return signup;
      }

      return availableToReserve ? reserve : disable;

    case memberStatusType('CANCELLED'):
      return reactivate;

    case memberStatusType('UNSUBSCRIBED'):
    default:
      return join;
  }
};

export default getScheduleAction;